declare global {
  interface Window {
    AppJsInterface?: {
      getFcmToken?: () => string;
    };
  }
}

export const NativeAppService = {
  get isNativeApp(): boolean {
    return typeof window !== "undefined" && window.AppJsInterface != null;
  },

  getNotificationToken(): string | null {
    return window.AppJsInterface?.getFcmToken?.() ?? null;
  },
};
